import Datetime from 'react-datetime'
import moment from 'moment'

import { type HeaderDocumentState } from '../../types'

interface Props {
  isView: boolean
  headerDoc: HeaderDocumentState
  updateHeaderDoc: (field: keyof HeaderDocumentState, value: any) => void
  sendTo: string
  setSendTo: (value: string) => void
}

const InstallationHeaderSection: React.FC<Props> = ({
  isView,
  headerDoc,
  updateHeaderDoc,
  sendTo,
  setSendTo,
}) => {
  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>หัวเอกสาร</div>
        </div>
        <div className='card-body'>
          <div className='row gy-4'>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>เลขที่</label>
              <input
                type='text'
                className='form-control form-control-sm'
                value={headerDoc.documentNo}
                disabled={isView}
                onChange={e => updateHeaderDoc('documentNo', e.target.value)}
              />
            </div>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>เลขที่แผ่นที่</label>
              <input
                type='text'
                className='form-control form-control-sm'
                value={headerDoc.mapNo}
                disabled={isView}
                onChange={e => updateHeaderDoc('mapNo', e.target.value)}
              />
            </div>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>จาก</label>
              <input
                type='text'
                className='form-control form-control-sm'
                value={headerDoc.department}
                disabled={isView}
                onChange={e => updateHeaderDoc('department', e.target.value)}
              />
            </div>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>วันที่</label>
              <Datetime
                locale='en'
                dateFormat='DD/MM/YYYY'
                timeFormat={false}
                value={headerDoc.documentDate ?? undefined}
                onChange={(val: any) => {
                  if (moment.isMoment(val) || val instanceof Date) {
                    updateHeaderDoc('documentDate', moment(val).toDate())
                  }
                }}
                renderInput={props => (
                  <input
                    {...props}
                    autoComplete='off'
                    className='form-control form-control-sm'
                    disabled={isView}
                  />
                )}
                closeOnClickOutside
              />
            </div>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>ชื่อลูกค้า</label>
              <input
                type='text'
                className='form-control form-control-sm'
                value={headerDoc.customerTitle}
                disabled={isView}
                onChange={e => updateHeaderDoc('customerTitle', e.target.value)}
              />
            </div>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>หน่วยงาน</label>
              <input
                type='text'
                className='form-control form-control-sm'
                value={headerDoc.division}
                disabled={isView}
                onChange={e => updateHeaderDoc('division', e.target.value)}
              />
            </div>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>ใบสั่งผลิต NO.</label>
              <input
                type='text'
                className='form-control form-control-sm'
                value={headerDoc.productionOrderNo}
                disabled={isView}
                onChange={e => updateHeaderDoc('productionOrderNo', e.target.value)}
              />
            </div>

            <div className='col-12'>
              <label className='form-label fs-7 fw-bold mb-1'>เรียน</label>
              <textarea
                className='form-control form-control-sm'
                rows={3}
                value={sendTo}
                disabled={isView}
                onChange={e => setSendTo(e.target.value)}
                placeholder='ระบุผู้รับ / หน่วยงานที่แจ้ง'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InstallationHeaderSection
